'use client';

import React, { useMemo, useRef, useState } from 'react';
import { useWindowScroll } from '@uidotdev/usehooks';
import classNames from 'classnames';
import { Button } from '@/features/button';
import { IconArrowSquareDown, IconArrowSquareUp } from '@/features/icons';
import { useMobileDetect } from '@/features/mobile-detect-context/mobile-detect-provider';
import SafeHtml from '@/components/safe-html';
import { SHOW_MORE_BUTTON_CHARACTER_LIMIT } from '@/app/(pdp)/constants';
import { PUBLIC_IS_BOT } from '@/app/_constants/search-engines';
import usePDPData from '../../_utils/use-pdp-data';
function Description() {
  const {
    isMobile
  } = useMobileDetect();
  const {
    data
  } = usePDPData();
  const description = data?.descriptionHtmlFa || '';
  const [isShowFullContent, setIsShowFullContent] = useState(PUBLIC_IS_BOT ?? false);
  const isTextOverflow = useMemo(() => description.length >= SHOW_MORE_BUTTON_CHARACTER_LIMIT, [description]);
  const scrollToElement = useRef(null);
  const [, scrollTo] = useWindowScroll();
  const offsetToTop = isMobile ? 552 : 230;
  function handleClick() {
    setIsShowFullContent(!isShowFullContent);
    if (isShowFullContent) scrollTo({
      top: offsetToTop,
      behavior: 'smooth'
    });
  }
  if (!description) return null;
  return <div className='border-border-surface-solid-0 mt-3 inline-flex flex-col items-center gap-2 overflow-hidden rounded border px-2 py-3 text-justify lg:items-end lg:gap-3' ref={scrollToElement} data-sentry-component="Description" data-sentry-source-file="description.tsx">
            <div data-test='pdp-description' className='relative flex w-full flex-col gap-2 lg:gap-3'>
                <h2 className='text-right text-body-14 font-bold text-text-black lg:text-body-16'> معرفی محصول </h2>
                <SafeHtml content={description} className={classNames('text-right text-caption-12 text-text-darkGray lg:text-body-14 [&>*]:!text-right [&>h2]:text-caption-12 [&>h2]:font-bold [&>h2]:lg:text-body-14 [&>h3]:text-caption-12 [&>h3]:font-bold [&>h3]:lg:text-body-14 [&>p]:mb-1 [&>p]:text-caption-12 [&>p]:lg:text-body-14', {
        'line-clamp-4 max-h-20 text-ellipsis lg:max-h-20': !isShowFullContent && isTextOverflow
      })} data-sentry-element="SafeHtml" data-sentry-source-file="description.tsx" />

                {!isShowFullContent && isTextOverflow && <div className='absolute bottom-0 right-0 h-3/4 w-full bg-gradient-to-t from-white' />}
            </div>
            <Button graphicStyle='text' size={isMobile ? 'xsmall' : 'small'} onClick={() => handleClick()} icon={{
      element: isShowFullContent ? <IconArrowSquareUp className='h-6 w-6' /> : <IconArrowSquareDown className='h-6 w-6' />,
      position: 'left'
    }} className={!isTextOverflow ? 'hidden' : '-mt-5 text-sm lg:-mt-3'} data-sentry-element="Button" data-sentry-source-file="description.tsx">
                {isShowFullContent ? 'مشاهده کمتر' : 'مشاهده بیشتر'}
            </Button>
        </div>;
}
export default Description;